import { Themes } from '../../../constants';
import { getThemeColor } from '../../../utils/common';
import { FORTA_BLACK, FORTA_BLUE, FORTA_ERROR, FORTA_WHITE } from '../../../utils/colors';

import type { SxProps, Theme } from '@mui/material';
import type { CSSProperties } from 'react';

export const SIGNATURE_BOX_CANVAS_STYLE: CSSProperties = { pointerEvents: 'auto' };
export const SIGNATURE_BOX_CANVAS_STYLE_DISABLED: CSSProperties = { pointerEvents: 'none' };

export const SIGNATURE_BOX_HELPER_TEXT_SX: SxProps<Theme> = {
  color: FORTA_ERROR,
  fontSize: 12,
  gridColumn: { xs: 1, sm: 2 },
  justifySelf: 'center',
  textAlign: 'center',
};

export const SIGNATURE_BOX_CLEAR_BUTTON_SX: SxProps<Theme> = {
  backgroundColor: FORTA_WHITE,
  borderColor: FORTA_BLUE.light2,
  borderStyle: 'solid',
  borderWidth: 1,
  color: getThemeColor(Themes.Primary).primary,
  width: 'fit-content',
};

export const SIGNATURE_BOX_SAVE_BUTTON_SX: SxProps<Theme> = { height: 40 };

export const SIGNATURE_BOX_ACTIONS_ROW_SX: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: 'minmax(0, 1fr) auto minmax(0, 1fr)' },
  mt: 1,
  rowGap: 1,
};

export const SIGNATURE_BOX_MESSAGE_SX: SxProps<Theme> = {
  color: FORTA_BLACK,
  fontSize: 16,
  gridColumn: 1,
  justifySelf: 'start',
};

export const SIGNATURE_BOX_BUTTONS_SX: SxProps<Theme> = {
  flexWrap: 'wrap',
  gridColumn: { xs: 1, sm: 3 },
  justifySelf: 'end',
};

export const SIGNATURE_BOX_PAPER_SX: SxProps<Theme> = {
  backgroundColor: FORTA_BLUE.light3,
  borderRadius: 0,
  borderBottom: `1px solid ${FORTA_BLUE.primary}`,
  boxShadow: 'none',
  overflow: 'hidden',
  position: 'relative',
};

export const SIGNATURE_BOX_PAPER_ERROR_SX: SxProps<Theme> = {
  borderBottom: `1px solid ${FORTA_ERROR}`,
};
